const FlightLoader = () => {
  return (
    <div className="loader-overlay">
      <img
        src={require("../../../src/images/qZHT5UX2cZ.gif")}
        alt="Loading..."
        style={{ width: 100, height: 100 }}
      />
    </div>
  );
};

export default FlightLoader;
